<template>
  <div :class="getCurrentDir" :dir="getCurrentDir">
    <div id="branches" class="warger" dir="ltr">
      <div class="bgImage"></div>
      <div class="container warger shadow-lg overflow-hidden">
        <div class="base" style="grid-template-rows: auto auto auto !important; ">
          <!-- Language Switcher -->
          

          <!-- Profile Header -->
          <div class="text-center pb-4 lg:py-6 px-4">
            <div class="text-center">
                <img
                    src="/Images/warger.png"
                    alt="Agora Vision Logo"
                    style="width: 90px; height: 90px"
                  />
            </div>
            <h1 class="text-xl m-0 text-agora-purple font-semibold">
              Agora Vision English
            </h1>
            <p class="mt-3 text-sm leading-relaxed">
              Stories from the Heart of Kurdistan, translated for readers around the world! 🌎
            </p>
          </div>

          <!-- Linktree Content -->
          <div class="grid justify-center gap-4 px-3 pb-4">
            
            <!-- Link 1: Amazon -->
            <a
              target="_blank"
              href="https://www.amazon.com/stores/Agora-Warger/author/B0FNMT89T6/allbooks?ccs_id=61f60f1b-702d-4b29-b593-118d1573543b"
              class="block"
            >
              <div class="w-full rounded-2xl shadow-lg warger p-4 text-center">
                Buy Available Books on Amazon
               
              </div>
            </a>

            <!-- Link 2: Translation & Publishing -->
            <a
              target="_blank"
              href="https://www.agoravision.site/visionenglish"
              class="block"
            >
              <div class="w-full rounded-2xl shadow-lg warger p-4 text-center">
                Translation & Publishing
                
              </div>
            </a>

            <!-- Link 3: Agora Vision Website -->
            <a
              target="_blank"
              href="https://www.agoravision.site"
              class="block"
            >
              <div class="w-full rounded-2xl shadow-lg warger p-4 text-center">
                Agora Vision Website
                
              </div>
            </a>

          </div>

          <!-- Bottom Section (kept from original style) -->
          <div class="text-gray-500">
            

            <div class="phone">
              <hr class="border-gray-200 shadow-lg mb-2" />
              <span
                class="text-md flex justify-around py-1 text-xs items-center"
                style="font-family: montserrat"
              >
                <a
                  :class="getCurrentDir == 'rtl' ? 'text-azher' : ''"
                  :dir="getCurrentDir"
                  style="font-family: 'Montserrat', sans-serif !important"
                  href="tel:009647702000545"
                  >{{ $t("ContactForm.PhoneOne") }}</a
                >
                <span class="pb-1">|</span>
                <a
                  :class="getCurrentDir == 'rtl' ? 'text-azher' : ''"
                  :dir="getCurrentDir"
                  style="font-family: 'Montserrat', sans-serif !important"
                  href="tel:009647502000545"
                  >{{ $t("ContactForm.PhoneTwo") }}</a
                >
              </span>
            </div>

            <div class="social flex justify-around text-lg py-1">
              <a href="https://www.facebook.com/agoravisioneng" target="_blank">
                <i class="fab fa-facebook-f" style="font-size:24px !important"></i>
              </a>
              <a href="https://www.instagram.com/agoravisioneng" target="_blank">
                <i class="fab fa-instagram" style="font-size:24px !important"></i>
              </a>
               <a href="https://www.tiktok.com/@agoravisioneng" target="_blank">
                <i class="fab fa-tiktok" style="font-size:24px !important"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["getCurrentLocale", "getCurrentDir", "getUser"]),
  title: "Agora Vision English",
  methods: {
    saveLocale() {
      sessionStorage.setItem("locale", this.$store.getters.getCurrentLocale);
    },
    switchLocale(newLocale) {
      this.$store.commit("changeLocale", newLocale);
      this.$i18n.locale = newLocale;
      this.toggled = false;
      document.querySelector("body").removeAttribute("class");
      document.querySelector("body").classList.add(this.getCurrentDir);
      setTimeout(() => {}, 300);
    },
  },
  mounted() {
    setTimeout(() => {
      this.switchLocale("en");
    }, 350);
  },
};
</script>

<style>
</style>